/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": "PdpRespSellerItemTileCarousel_item";
};
export type PdpRespSellerItemTileCarousel_item$data = PdpRespSellerItemTileCarousel_item;
export type PdpRespSellerItemTileCarousel_item$key = {
    readonly " $data"?: PdpRespSellerItemTileCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItemTileCarousel_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemTileCarousel_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '000b3f69e1e553ac4246fc39e2322dcb';
export default node;
